/** Weighted random pick over a list, given a per-item weight accessor. */
export function weightedPick<T>(items: readonly T[], weightOf: (item: T) => number): T {
  let total = 0
  for (const it of items) total += weightOf(it)
  let r = Math.random() * total
  for (const it of items) {
    r -= weightOf(it)
    if (r <= 0) return it
  }
  return items[items.length - 1]
}
